import { render } from "./TheHeader.vue?vue&type=template&id=7810531a"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=7810531a&lang=css"

import exportComponent from "C:\\www\\webdesign - zelena\\vue\\dotacezelena-cz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__